import { useCallback, useMemo, useState } from 'react';

import * as columnDefs from '../../../../../components/AGGrid/config/columns-def';
import {filterCriteria} from "../../../../../utils/filterCriteria";

export function useContactsGridUtils({
                                         datastageApi,
                                         filterForm,
                                         defaultFilterRange,
                                         updateContacts,
                                     handlers
                                     }) {
    const [sortedColId, setSortedColId] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    const setSort = useCallback(
        async (colId, direction) => {
            setSortedColId(colId);
            setSortDirection(direction);
            handlers.setLoadingTrue();
            try {
                const data = await datastageApi.contacts(
                    filterCriteria(filterForm, '', 'contacts'),
                    defaultFilterRange,
                    [colId, direction.toUpperCase()]
                );
                updateContacts({
                    contacts: data?.content,
                    totalPages: data?.totalPages,
                    totalItems: data?.totalElements,
                    currentPage: data?.pageable?.pageNumber,
                    contactSort: [colId, direction.toUpperCase()]
                });
            } catch (error) {
                console.error('Error sorting contacts:', error);
            } finally {
                handlers.setLoadingFalse();
            }
        },
        [filterForm, defaultFilterRange, updateContacts, handlers]
    );

    const baseColumns = columnDefs['contacts'](
        ...handlers.columnHandlers
    )['default'];

    const columns = useMemo(() => (
        baseColumns.map(col => ({
            ...col,
            headerComponentParams: {
                ...col.headerComponentParams,
                setSort,
                sortedColId,
                sortDirection,
            }
        }))
    ), [setSort, sortedColId, sortDirection, baseColumns]);

    return { setSort, columns };
}